import { apiService } from './apiService';
import { AnnotatorAccessDto, AnnotatorsListDto } from 'types/api.types';

const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};

export const getAnnotatorAccessList = async (): Promise<AnnotatorsListDto | null> => {
  try {
    return await apiService.get<AnnotatorsListDto>('/admin/annotators');
  } catch (error) {
    console.error('Failed to load annotators:', error);
    return null;
  }
};

export const assignAnnotator = async (
  annotatorEmail: string,
): Promise<AnnotatorAccessDto | null> => {
  try {
    return await apiService.post<AnnotatorAccessDto>('/admin/annotators', {
      annotatorEmail,
    });
  } catch (error) {
    console.error('Failed to assign annotator:', error);
    return null;
  }
};

export const updateAnnotatorAccess = async (
  annotatorEmail: string,
  isActive: boolean,
): Promise<AnnotatorAccessDto | null> => {
  try {
    return await apiService.patch<AnnotatorAccessDto>('/admin/annotators', {
      annotatorEmail,
      isActive,
    });
  } catch (error) {
    console.error('Failed to update annotator access:', error);
    return null;
  }
};

export interface RemoveAnnotatorResult {
  success: boolean;
  errorMessage?: string;
}

export const removeAnnotatorAccess = async (
  annotatorEmail: string,
): Promise<RemoveAnnotatorResult> => {
  try {
    await apiService.delete<void>(
      `/admin/annotators?annotatorEmail=${encodeURIComponent(annotatorEmail)}`,
    );
    return { success: true };
  } catch (error) {
    console.error('Failed to remove annotator access:', error);
    return {
      success: false,
      errorMessage: getErrorMessage(error, 'Unable to remove annotator access.'),
    };
  }
};
